export default "__VITE_ASSET__e7704950__"